<script>
import Vuex from "vuex";
import axios from "axios";
import TicoLogo from "../shared/tico-logo.vue";
export default {
    name: "DirectForm",
    components: {TicoLogo},
    data() {
        return {
            eventList: []
        };
    },
    computed: {
        ...Vuex.mapState(['directFormData']),
        formCarbon: {
            get() { return this.directFormData.carbon; },
            set(value) { this.$store.commit("directFormData/setCarbon", value); }
        },
        formEvent: {
            get() { return this.directFormData.formEvent; },
            set(value) { this.$store.commit("directFormData/setFormEvent", value); }
        }
    },
    methods: {
        formSubmit() {
            console.log("submitting!");
            this.$router.push("/carbonpay");
        },
        async setup() {
            this.eventList = await axios.get(this.$store.getters["server"] + "/events", {headers: {"Access-Control-Allow-Origin": this.$store.getters["server"]}})
                .then((data) => {
                    console.log(data.data.events);
                    return data.data.events;
                });
        }
    },
    mounted() {
        this.setup();
    }
};
</script>

<template>
    <div id="home">
        <tico-logo></tico-logo>
        <div class="about"><p>Ready to offset your carbon footprint? Offset emissions by supporting
            a Native American carbon project.</p>
            <p>Enter a small amount of information to make a big difference.</p>
            </div>
        <form id="frontPageForm" @submit.prevent="formSubmit">
            <div id="offsets"><label for="carbon">Quantity of carbon offsets:</label> <input type="number" min="0" id="carbon" placeholder="Metric tons of carbon" v-model="formCarbon" required></div>
            <div id="event">
                <div class="form-icon"><i class="far fa-calendar"></i></div>
                <label for="eventSelect" class="select-wrap">
                    <select name="event" id="eventSelect" v-model="formEvent" required>
                        <option disabled selected hidden value="">Find Your Event or Organization</option>
                        <option v-if="event.active" v-for="event in eventList" :value="event">{{event.name}}</option>
                    </select>
                </label>
            </div>
            <div id="formButtonWrap"><button class="button-submit" id="frontPageSubmit"><span><span class="title">Offset Your Carbon Footprint</span></span></button></div>
        </form>
<!--        <ul id="eventList">-->
<!--            <li class="front-page-event" v-for="event in eventList" v-if="event.active">-->
<!--                <div class="event-list-trees">-->
<!--                    <span class="tree-value"><i class="fas fa-tree event-list-tree"></i> {{Math.round(event.trees)}} tree{{Math.round(event.trees) === 1 ? "" : "s"}}</span> <span class="tree-subhead">of carbon offsets for</span>-->
<!--                </div>-->
<!--                <div class="event-list-name"><router-link :to="'/event/' + event.id">{{event.name}}</router-link></div>-->
<!--            </li>-->
<!--        </ul>-->
    </div>

</template>

<style scoped lang="less">
@import (reference) "../../assets/variables";
.about{
    text-align: left;
}
    #offsets{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.3rem;
        margin: 2rem 0;
    }
    #carbon{
        border: 1px solid @gray;
        max-width: 40%;
        margin-left: 1em;
    }
    #event{
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 2px solid @lightest-gray;
        margin-bottom: 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/direct-contribute/DirectForm.vue